import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-one-lesson-four-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['./_guide.component.css']
})
export class UnitOneLessonFourGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 1, Lesson 4 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 4: Needs";

    doPrint(): void {
        window.print();
    }
    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
